import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=26ae0127&lang=pug&"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ae0127')) {
      api.createRecord('26ae0127', component.options)
    } else {
      api.reload('26ae0127', component.options)
    }
    module.hot.accept("./TestimonialCarousel.vue?vue&type=template&id=26ae0127&lang=pug&", function () {
      api.rerender('26ae0127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/TestimonialCarousel.vue"
export default component.exports